export default "__VITE_ASSET___HWuwQBu__"